document.addEventListener('DOMContentLoaded', function () {
    const container = document.querySelector('[data-video-container]');
    const video = container.querySelector('[data-video]');
    const playButton = container.querySelector('[data-play-button]');

    function playVideo() {
        container.classList.add('is-playing');
        video.style.display = 'block';
        video.focus();
        video.play();
    }

    // Click or keyboard activation
    playButton.addEventListener('click', playVideo);
    playButton.addEventListener('keydown', (e) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            playVideo();
        }
    });

    // Optional: allow pressing space/enter on container placeholder
    container.addEventListener('keydown', (e) => {
        if ((e.key === "Enter" || e.key === " ") && !container.classList.contains('is-playing')) {
            e.preventDefault();
            playVideo();
        }
    });
})